import React from 'react';
import PropTypes from 'prop-types';
import { Box, Grid } from '@material-ui/core';

import { Card } from 'core/components/card';
import { Label } from 'core/components/label';
import { TruncatedText } from 'core/components/truncated-text';
import externalLinkIcon from 'core/assets/svg/external-link.svg';
import { IconButtonWithTooltip } from 'core/components/icon-button-with-tooltip';

import useStyles from './inventory-item-card.styles';

export const InventoryItemCard = ({ title, primaryLabel, primaryText, imageUrl }) => {
  const classes = useStyles();

  return (
    <Card type="primary" className={classes.inventoryCard}>
      {imageUrl && (
        <div
          className={classes.imageContainer}
          onClick={() => {
            window.open(imageUrl, '_blank');
          }}
        >
          <img src={imageUrl} alt={title} className={classes.image} />
        </div>
      )}
      <div className={classes.content}>
        {primaryLabel && (
          <Grid container alignItems="flex-start" className={classes.row}>
            <Grid item xs>
              <Box display="flex" flexDirection="column">
                <Label type="caption" className={classes.rowLabel}>
                  {primaryLabel}
                </Label>
                <TruncatedText maxLength={25} text={primaryText} className={classes.rowText} />
              </Box>
            </Grid>
            <Grid
              item
              className={classes.actionIconContainer}
              onClick={() => {
                window.open(imageUrl, '_blank');
              }}
            >
              <IconButtonWithTooltip
                tooltip="Open image in new tab"
                icon={externalLinkIcon}
                alt="Open image in new tab"
                tooltipClassName={classes.tooltip}
                iconClassName={classes.actionIcon}
              />
            </Grid>
          </Grid>
        )}
      </div>
    </Card>
  );
};

InventoryItemCard.propTypes = {
  title: PropTypes.string,
  imageUrl: PropTypes.string,
  primaryLabel: PropTypes.string,
  primaryText: PropTypes.node
};
